import type { AccountTransaction } from './account-transaction.type.ts';
export interface AccountTransactionExtension extends AccountTransaction {}
export class AccountTransactionExtension {
  /**************************
   **  Computed Properties **
   **************************/
  get rejectionReason(): string {
    const transitionLog =
      (this.transitionLog as Array<{ to: string; reason: { note: string } }>) ?? [];
    const rejection = transitionLog.find(
      (logItem) => logItem.to === 'TransactionVerificationState.REJECTED'
    );
    return rejection?.reason?.note || '';
  }
}

const Registration = {
  kind: 'object',
  name: 'account-transaction',
  features: AccountTransactionExtension,
};
export default Registration;
